import BaseApiService from "./base-services/baseApi.service";

class SharedApiService extends BaseApiService {
    constructor() {
        super();
    }

    saveErrorLogData = async (data) => {
        const url = `/auth/log-web-error`;
        const res = await this.axiosInstance.post(url, data);
        return res.data;
    };
}

const sharedApiService = new SharedApiService();
export { sharedApiService };
